import _ from 'lodash';
import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';

import OrderDeviceSectionView from '../../../views/OrderDeviceSectionView';
import SaveCustomerOrderDevices from '../../../services/SaveCustomerOrderDevices';
import UpdateOrderLineItems from '../../../services/UpdateOrderLineItems';
import ReloadViewModule from '../../../services/ReloadViewModule';

import tmplWideFormatFormView from './WideFormatFormView.hbs';

const WideFormatFormView = View.extend({
  template: tmplWideFormatFormView,

  className: 'wide-format-form-view',

  ui: {
    descriptionSection: '.description-section',
    printerSection: '.printer-section',
    scannerSection: '.scanner-section',
    cartridgeSection: '.cartridge-section',
    printerCONUSSection: '.printer-conus-section',
    scannerCONUSSection: '.scanner-conus-section',
    cartridgeCONUSSection: '.cartridge-conus-section',
    printerOCONUSSection: '.printer-oconus-section',
    scannerOCONUSSection: '.scanner-oconus-section',
    cartridgeOCONUSSection: '.cartridge-oconus-section',
    devicesAlert: '.no-devices-error'
  },

  regions: {
    descriptionSection: '@ui.descriptionSection',
    printerSection: '@ui.printerSection',
    scannerSection: '@ui.scannerSection',
    cartridgeSection: '@ui.cartridgeSection',
    printerCONUSSection: '@ui.printerCONUSSection',
    scannerCONUSSection: '@ui.scannerCONUSSection',
    cartridgeCONUSSection: '@ui.cartridgeCONUSSection',
    printerOCONUSSection: '@ui.printerOCONUSSection',
    scannerOCONUSSection: '@ui.scannerOCONUSSection',
    cartridgeOCONUSSection: '@ui.cartridgeOCONUSSection'
  },

  onRender() {
    const isAdminEdit = this.model.get('orderDetails').isAdminEdit;

    this.showChildView(
      'descriptionSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          title: 'Device Information',
          type: 'description',
          id: 'description',
          contract: 'Wide Format',
          isAdminEdit
        })
      })
    );

    //if devices are split into different panels by CONUS vs. OCONUS, call renderConusOconusPanels(), else call renderOldPanels
    const checkPanelName = (val, obj) => _.some(obj, (v) => _.includes(v, val));
    this.isConusOconus = checkPanelName('CONUS', this.model.get('lineItems')[0]);

    this.isConusOconus ? this.renderConusOconusPanels() : this.renderOldPanels();
  },

  renderConusOconusPanels() {
    const orderType = this.model.get('orderDetails').orderTypeId;
    const isAdminEdit = this.model.get('orderDetails').isAdminEdit;

    const { PrinterCONUS, ScannerCONUS, CartridgeCONUS, PrinterOCONUS, ScannerOCONUS, CartridgeOCONUS } = _.groupBy(
      this.model.get('lineItems'),
      'panel'
    );
    this.orderDeviceSectionView = new OrderDeviceSectionView();

    this.showChildView(
      'printerCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: PrinterCONUS,
          title: 'Wide Format - Printers/Multifunctional Devices (MFDs) [CONUS]',
          id: 'printerCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'scannerCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: ScannerCONUS,
          title: 'Wide Format Scanner [CONUS]',
          id: 'wideCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'cartridgeCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: CartridgeCONUS,
          title: 'Ink Cartridges for Wide Format Printers/MFDs [CONUS]',
          id: 'legacyCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'printerOCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: PrinterOCONUS,
          title: 'Wide Format - Printers/Multifunctional Devices (MFDs) [AK/HI/PR Orders Only]',
          id: 'printerOCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'scannerOCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: ScannerOCONUS,
          title: 'Wide Format Scanner [AK/HI/PR Orders Only]',
          id: 'wideOCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'cartridgeOCONUSSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: CartridgeOCONUS,
          title: 'Ink Cartridges for Wide Format Printers/MFDs [AK/HI/PR Orders Only]',
          id: 'legacyOCONUS',
          orderType,
          isAdminEdit
        })
      })
    );
  },

  renderOldPanels() {
    const orderType = this.model.get('orderDetails').orderTypeId;
    const isAdminEdit = this.model.get('orderDetails').isAdminEdit;

    const { Printer, Scanner, Cartridge } = _.groupBy(this.model.get('lineItems'), 'panel');

    this.showChildView(
      'printerSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: Printer,
          title: 'Wide Format - Printers/Multifunctional Devices (MFDs)',
          id: 'printer',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'scannerSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: Scanner,
          title: 'Wide Format Scanner',
          id: 'wide',
          orderType,
          isAdminEdit
        })
      })
    );
    this.showChildView(
      'cartridgeSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: Cartridge,
          title: 'Ink Cartridges for Wide Format Printers',
          id: 'legacy',
          orderType,
          isAdminEdit
        })
      })
    );
  },

  async validate() {
    let isValid = true;
    const colls = await this.getWideFormatDeviceData();

    if (
      !colls.printerCONUSColl?.totalPrinterCONUSQuantity &&
      !colls.scannerCONUSColl?.totalScannerCONUSQuantity &&
      !colls.cartridgeCONUSColl?.totalCartridgeCONUSQuantity &&
      !colls.printerOCONUSColl?.totalPrinterOCONUSQuantity &&
      !colls.scannerOCONUSColl?.totalScannerOCONUSQuantity &&
      !colls.cartridgeOCONUSColl?.totalCartridgeOCONUSQuantity &&
      !colls.printerColl?.totalPrinterQuantity &&
      !colls.wideColl?.totalWideInkQuantity &&
      !colls.legacyColl?.totalLegacyInkQuantity
    ) {
      isValid = false;
      this.ui.devicesAlert.show();
    }

    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async getWideFormatDeviceData() {
    const colls = {};
    if (this.isConusOconus) {
      colls.printerCONUSColl = await this.getChildView('printerCONUSSection').getDeviceData();
      colls.scannerCONUSColl = await this.getChildView('scannerCONUSSection').getDeviceData();
      colls.cartridgeCONUSColl = await this.getChildView('cartridgeCONUSSection').getDeviceData();
      colls.printerOCONUSColl = await this.getChildView('printerOCONUSSection').getDeviceData();
      colls.scannerOCONUSColl = await this.getChildView('scannerOCONUSSection').getDeviceData();
      colls.cartridgeOCONUSColl = await this.getChildView('cartridgeOCONUSSection').getDeviceData();
    } else {
      colls.printerColl = await this.getChildView('printerSection').getDeviceData();
      colls.wideColl = await this.getChildView('scannerSection').getDeviceData();
      colls.legacyColl = await this.getChildView('cartridgeSection').getDeviceData();
    }
    return colls;
  },

  getLineItemData(lineItemData) {
    const lineItems = this.model.get('lineItems');
    const changedItems = [];

    _.each(lineItems, (item) => {
      const changedPrice = lineItemData[`${item.id}-price`];
      const changedDlaCost = lineItemData[`${item.id}-dlaCost`];
      const changedModel = lineItemData[`${item.id}-model`];
      const changedVolumeBand = lineItemData[`${item.id}-volumeBand`];
      const changedCompatibleDevice = lineItemData[`${item.id}-compatibleDevice`];
      const changedDesc = lineItemData[`${item.id}-description`];

      const isPriceChanged = item.price !== changedPrice && item.price;
      const isDlaCostChanged = (item.dlaCost !== changedDlaCost) && !!item.dlaCost;
      const isModelChanged = item.model !== changedModel && item.model;
      const isVolumeBandChanged = item.volumeBand !== changedVolumeBand && item.volumeBand;
      const isCompatibleDeviceChanged = item.compatibleDevice !== changedCompatibleDevice && item.compatibleDevice;
      const isDescChanged = item.description !== changedDesc && item.description;

      const changedItem = {};
      if (isPriceChanged) changedItem.price = parseFloat(changedPrice).toFixed(2);
      if (isDlaCostChanged) changedItem.dlaCost = changedDlaCost;
      if (isModelChanged) changedItem.model = changedModel;
      if (isVolumeBandChanged) changedItem.volumeBand = changedVolumeBand;
      if (isCompatibleDeviceChanged) changedItem.compatibleDevice = changedCompatibleDevice;
      if (isDescChanged) changedItem.description = changedDesc;
      if (!_.isEmpty(changedItem)) {
        changedItem.id = item.id;
        changedItems.push(changedItem);
      }
    });

    return changedItems;
  },

  async onSave(lineItemData) {
    this.ui.devicesAlert.hide();
    this.trigger('no:errors');
    const isAdminEdit = this.model.get('orderDetails').isAdminEdit;
    let formData;

    try {
      if (isAdminEdit && lineItemData) {
        formData = await this.saveAdminEdit(lineItemData);
        if (formData.changedItems.length > 0) {
          await UpdateOrderLineItems(formData);
          this.showSaveSuccess();
        } else {
          this.showNoChangedDevicesError();
        }
      } else {
        formData = await this.saveOrder();
        await Promise.all([SaveCustomerOrderDevices(formData), ReloadViewModule.reload()]);
        this.showSaveSuccess();
      }
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  async saveOrder() {
    const printerSection = this.getChildView('printerSection');
    const scannerSection = this.getChildView('scannerSection');
    const cartridgeSection = this.getChildView('cartridgeSection');
    const isOldWideFormat = printerSection || scannerSection || cartridgeSection;
    let oldWideFormatColls = {};

    const printerCONUSSection = this.getChildView('printerCONUSSection');
    const scannerCONUSSection = this.getChildView('scannerCONUSSection');
    const cartridgeCONUSSection = this.getChildView('cartridgeCONUSSection');
    const printerOCONUSSection = this.getChildView('printerOCONUSSection');
    const scannerOCONUSSection = this.getChildView('scannerOCONUSSection');
    const cartridgeOCONUSSection = this.getChildView('cartridgeOCONUSSection');
    const isConusOconus =
      printerCONUSSection ||
      scannerCONUSSection ||
      cartridgeCONUSSection ||
      printerOCONUSSection ||
      scannerOCONUSSection ||
      cartridgeOCONUSSection;
    let conusOconusColls = {};

    let totals = {
      totalPrinterPrice: 0,
      totalScannerPrice: 0,
      totalInkPrice: 0,
      totalPrinterQuantity: 0,
      totalScannerQuantity: 0,
      totalInkQuantity: 0
    };
    let devicesFormData = [];
    let colls = {};

    if (isConusOconus) {
      colls = await this.getWideFormatDeviceData();
      conusOconusColls = {
        printerCONUSColl: colls.printerCONUSColl,
        scannerCONUSColl: colls.scannerCONUSColl,
        cartridgeCONUSColl: colls.cartridgeCONUSColl,
        printerOCONUSColl: colls.printerOCONUSColl,
        scannerOCONUSColl: colls.scannerOCONUSColl,
        cartridgeOCONUSColl: colls.cartridgeOCONUSColl
      };
      totals = this.saveConusOconusOrder(totals, conusOconusColls);
      devicesFormData = this.getConusOconusDevicesFormData(conusOconusColls);
    }
    if (isOldWideFormat) {
      colls = await this.getWideFormatDeviceData();
      oldWideFormatColls = {
        printerColl: colls.printerColl,
        scannerColl: colls.wideColl,
        cartridgeColl: colls.legacyColl
      };

      totals = this.saveOldWideFormatOrder(totals, oldWideFormatColls);
      devicesFormData = this.getOldWideFormatDevicesFormData(oldWideFormatColls);
    }

    const totalOrderPrice = totals.totalPrinterPrice + totals.totalScannerPrice + totals.totalInkPrice;
    const totalOrderQuantity = totals.totalPrinterQuantity + totals.totalScannerQuantity + totals.totalInkQuantity;

    const orderFormData = {
      totalOrderPrice,
      totalOrderQuantity,
      totalPrinterPrice: totals.totalPrinterPrice,
      totalPrinterQuantity: totals.totalPrinterQuantity,
      totalScannerPrice: totals.totalScannerPrice,
      totalScannerQuantity: totals.totalScannerQuantity,
      totalInkPrice: totals.totalInkPrice,
      totalInkQuantity: totals.totalInkQuantity
    };

    const formData = {
      devicesFormData,
      orderFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId,
      itPocExists: true
    };

    return formData;
  },

  saveConusOconusOrder(totals, colls) {
    totals.totalPrinterPrice =
      colls.printerCONUSColl?.totalPrinterCONUSPrice + colls.printerOCONUSColl?.totalPrinterOCONUSPrice || 0;
    totals.totalPrinterQuantity =
      colls.printerCONUSColl?.totalPrinterCONUSQuantity + colls.printerOCONUSColl?.totalPrinterOCONUSQuantity || 0;

    totals.totalScannerPrice =
      colls.scannerCONUSColl?.totalScannerCONUSPrice + colls.scannerOCONUSColl?.totalScannerOCONUSPrice || 0;
    totals.totalScannerQuantity =
      colls.scannerCONUSColl?.totalScannerCONUSQuantity + colls.scannerOCONUSColl?.totalScannerOCONUSQuantity || 0;

    totals.totalInkPrice =
      colls.cartridgeCONUSColl?.totalCartridgeCONUSPrice + colls.cartridgeOCONUSColl?.totalCartridgeOCONUSPrice || 0;
    totals.totalInkQuantity =
      colls.cartridgeCONUSColl?.totalCartridgeCONUSQuantity + colls.cartridgeOCONUSColl?.totalCartridgeOCONUSQuantity ||
      0;

    return totals;
  },

  saveOldWideFormatOrder(totals, colls) {
    totals.totalPrinterPrice = colls.printerColl?.totalPrinterPrice || 0;
    totals.totalPrinterQuantity = colls.printerColl?.totalPrinterQuantity || 0;

    totals.totalScannerPrice = colls.scannerColl?.totalScannerPrice || 0;
    totals.totalScannerQuantity = colls.scannerColl?.totalScannerQuantity || 0;

    totals.totalInkPrice = colls.cartridgeColl?.totalCartridgePrice || 0;
    totals.totalInkQuantity = colls.cartridgeColl?.totalCartridgeQuantity || 0;

    return totals;
  },

  getConusOconusDevicesFormData(colls) {
    const devicesFormData =
      colls.printerCONUSColl?.changedItems?.concat(
        colls.scannerCONUSColl?.changedItems || [],
        colls.cartridgeCONUSColl?.changedItems || [],
        colls.printerOCONUSColl?.changedItems || [],
        colls.scannerOCONUSColl?.changedItems || [],
        colls.cartridgeOCONUSColl?.changedItems || []
      ) || [];

    return devicesFormData;
  },

  getOldWideFormatDevicesFormData(colls) {
    const devicesFormData =
      colls.printerColl?.changedItems?.concat(
        colls.scannerColl?.changedItems || [],
        colls.cartridgeColl?.changedItems || []
      ) || [];
    return devicesFormData;
  },

  async saveAdminEdit(lineItemData) {
    const changedItems = this.getLineItemData(lineItemData);
    const formData = {
      orderFormTypeID: this.model.get('orderDetails').orderTypeId,
      changedItems
    };

    return formData;
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occured while saving devices for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  showNoChangedDevicesError() {
    showErrorMessage({
      errorCode: 'noChangedDevicesError',
      errorTitle: 'No Devices Updated Error',
      errorMessage: 'No devices were updated. Please update devices in order to save changes.'
    });
  }
});

export default WideFormatFormView;
